import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { SlitherlinkPresence } from "./Player";
import { registerSlitherlinkTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  SlitherlinkDefinition,
  SlitherlinkProgress,
  SlitherlinkSolution,
  SlitherlinkSubmission,
} from "./types";

registerSlitherlinkTranslations(i18n);

export const slitherlinkModule: PuzzleTypeModule<
  SlitherlinkDefinition,
  SlitherlinkSubmission,
  SlitherlinkProgress,
  SlitherlinkSolution,
  SlitherlinkPresence
> = {
  key: "slitherlink",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
